import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Slider from 'react-slick';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import Image from 'next/image';

const useStyles = makeStyles(theme => ({
  imageWrapper: {
    textAlign: 'center',
    backgroundColor: '#EBEDF2',
    lineHeight: 0,
    position: 'relative',
    width: '100%',
    height: 330,
    overflow: 'hidden',
    [theme.breakpoints.up('md')]: {
      height: 430,
    },
  },
  leftArrow: {
    position: 'absolute',
    left: 10,
    top: 125,
    zIndex: 10,
    [theme.breakpoints.up('md')]: {
      left: 40,
      top: 190,
    },
  },
  rightArrow: {
    position: 'absolute',
    right: 10,
    top: 125,
    zIndex: 10,
    transform: 'rotate(180deg)',
    [theme.breakpoints.up('md')]: {
      right: 40,
      top: 190,
    },
  },
  '@global': {
    '.slick-dots': {
      bottom: 15,
      [theme.breakpoints.up('md')]: {
        bottom: 25,
      },
    },
    '.slick-dots li button:before': {
      display: 'none',
    },
    '.slick-dots li button': {
      background: '#fff',
      content: '',
      borderRadius: 20,
      width: 10,
      height: 10,
    },
    '.slick-dots li.slick-active button': {
      background: '#076BD1',
    },
  },
}));

function NextArrow(props) {
  const classes = useStyles();
  const { onClick } = props;
  return (
    <IconButton aria-label="delete" onClick={onClick} className={classes.rightArrow}>
      <ArrowBackIcon />
    </IconButton>
  );
}

function PrevArrow(props) {
  const classes = useStyles();
  const { onClick } = props;
  return (
    <IconButton aria-label="delete" onClick={onClick} className={classes.leftArrow}>
      <ArrowBackIcon />
    </IconButton>
  );
}

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
};

const Carousel = ({ images = [] }) => {
  const classes = useStyles();
  return images.length > 0 ? (
    <Slider {...settings}>
      {images.map(({ url }, i) => {
        return (
          <div key={i} className={classes.imageWrapper}>
            <Image
              layout="fill"
              objectFit="contain"
              src={url || '/static/images/product-placeholder.jpg'}
            />
          </div>
        );
      })}
    </Slider>
  ) : (
    <div className={classes.imageWrapper}>
      <Image layout="fill" objectFit="contain" src={'/static/images/product-placeholder.jpg'} />
    </div>
  );
};

Carousel.propTypes = {
  classes: PropTypes.object.isRequired,
  images: PropTypes.array,
};

export default Carousel;
